/* eslint-disable camelcase */
import { h, render } from 'preact';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from '../utils/image';

const parseShopifyAttributes = (str) => {
  if (!str) return {};
  const attrPattern = /([a-zA-Z0-9-_]+)="([^"]+)"/g;
  const matches = [...str.matchAll(attrPattern)];
  const retVal = {};
  matches.forEach(([_, key, val]) => {
    retVal[key] = val.replaceAll('&quot;', '"');
  });
  return retVal;
};

export default (element, data) => {
  const Article = (props) => (
    <Swiper
      slidesPerView={1.06}
      breakpoints={{
        768: {
          slidesPerView: 3,
        },
      }}
    >
      {props.articles.map(
        (
          {
            image,
            heading,
            subheading,
            paragraph,
            // eslint-disable-next-line camelcase
            article_link,
            shopifyAttributes,
          },
          index,
        ) => (
          <SwiperSlide
            {...parseShopifyAttributes(shopifyAttributes)}
            key={index}
            className={`
            ${
          index !== 0 && index + 1 !== props.articles.length
            ? 'border-r border-r-grey-400 px-4 tablet:px-10'
            : ''
          } 
            ${index === 0 ? 'border-r border-r-grey-400 px-4 tablet:px-10' : ''}
            ${index + 1 === props.articles.length ? 'px-4 tablet:px-10' : ''}
            !h-auto
          `}
          >
            <a {...(article_link ? { href: article_link } : {})}>
              <div className="mb-6 tablet:mb-7">
                <Image
                  {...image}
                  srcWidths={{
                    sm: 570,
                    md: 175,
                    lg: 260,
                    xl: 553,
                    '2xl': 553,
                  }}
                  className="w-full object-cover h-[284px] tablet:h-[360px]"
                />
              </div>
              <h3
                className={`heading-5 mb-3 tablet:heading-6 ${props.colors.mobile} ${props.colors.desktop}`}
              >
                {heading}
              </h3>
              <p
                className={`font-m-14 mb-7 tablet:mb-6 ${props.colors.mobile} ${props.colors.desktop}`}
              >
                {subheading}
              </p>
              <p className="font-r-14">{paragraph}</p>
            </a>
          </SwiperSlide>
        ),
      )}
    </Swiper>
  );

  const init = () => {
    render(<Article {...data} />, element);
  };

  init();
};
